export const DEFAULT_STATE = {
  // trackloginuserData: {},
  dashboardfiltertrackingData: {},
  downloadMetricsExcelData: {},
  metricsTypeGraphData: {},
  metricsUserListData:{},
  downloadSearchFilterExcelData: {}
};
